<template>
    <v-container grid-list-md>
        <!-- breadcrumb, header -->
        <v-layout row wrap>
            <v-flex xs12 d-flex align-center>
                <h3 class="green--text headline mb-0">
                    {{ sponsorshipId ? 'Detalle de patrocinio' : 'Nuevo patrocinio' }}
                </h3>
            </v-flex>
            <!-- Detail -->
            <template v-if="!formSectionsEditMode.header && this.sponsorshipId">
                <v-flex xs12 sm3>Límite de usuarios: {{ this.currentSponsorship.usage_limit }}</v-flex>
                <v-flex xs12 sm2>Tipo: {{ this.currentSponsorship.type }}</v-flex>
                <v-flex xs12 sm3>Fecha de inicio: {{ this.currentSponsorship.date_from }}</v-flex>
                <v-flex xs12 sm3>Fecha de fin: {{ this.currentSponsorship.date_to }}</v-flex>
                <v-flex xs12 sm1>
                    <v-btn flat icon color="green" @click="formSectionsEditMode.header = true">
                        <v-icon>edit</v-icon>
                    </v-btn>
                </v-flex>
            </template>

            <!-- Form -->
            <template v-if="formSectionsEditMode.header || !this.sponsorshipId">
                <v-flex xs12 sm3>
                    <v-text-field
                        label="Límite de usuarios"
                        color="green"
                        v-model="form.usage_limit"
                        :rules="rules.required"
                        ref="usage_limit"
                        type="number"
                        required>
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                    <v-select
                        :items="sponsorshipTypes"
                        v-model="form.type"
                        label="Tipo de patrocinio"
                        single-line
                        item-text="text"
                        item-value="value"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm6 text-xs-right>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-menu
                                ref="startDateMenu"
                                :close-on-content-click="false"
                                v-model="startDateMenu"
                                :nudge-right="40"
                                :return-value.sync="form.date_from"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                            >
                                <v-text-field
                                    slot="activator"
                                    v-model="form.date_from"
                                    label="Fecha de Inicio"
                                    prepend-icon="event"
                                    color="green"
                                    readonly
                                    :rules="rules.required"
                                    ref="date_from"
                                ></v-text-field>
                                <v-date-picker v-model="form.date_from" @input="startDateMenu = false"></v-date-picker>

                            </v-menu>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-menu
                                ref="endDateMenu"
                                :close-on-content-click="false"
                                v-model="endDateMenu"
                                :nudge-right="40"
                                :return-value.sync="form.date_to"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                            >
                                <v-text-field
                                    slot="activator"
                                    v-model="form.date_to"
                                    label="Fecha de fin"
                                    prepend-icon="event"
                                    color="green"
                                    readonly
                                    :rules="rules.required"
                                    ref="date_to"
                                    ></v-text-field>
                                <v-date-picker v-model="form.date_to" @input="endDateMenu = false"></v-date-picker>

                            </v-menu>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </template>
            
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12>
                <v-toolbar color="white">
                    <v-toolbar-title class="green--text">Titulo</v-toolbar-title>
                </v-toolbar>
            </v-flex>
            <v-flex xs12 sm6>
                <v-toolbar color="grey darken-3">
                    <v-toolbar-title class="green--text">Español</v-toolbar-title>
                </v-toolbar>
            </v-flex>
            <v-flex xs12 sm6>
                <v-toolbar color="grey darken-3">
                    <v-toolbar-title class="green--text">Inglés</v-toolbar-title>
                </v-toolbar>
            </v-flex>
            <v-flex xs12 sm6>
                <TitleCard
                    lang="es"
                    ref="titleCardEs"
                    :editMode="formSectionsEditMode.header"
                    @update="onTitleUpdated"></TitleCard>
            </v-flex>
            <v-flex xs12 sm6>
                <TitleCard
                    lang="en"
                    ref="titleCardEn"
                    :editMode="formSectionsEditMode.header"
                    @update="onTitleUpdated"></TitleCard>
            </v-flex>
            <v-flex xs12 d-flex align-right v-if="formSectionsEditMode.header">
                <v-btn small color="red" @click="formSectionsEditMode.header = false">Cancelar</v-btn>
                <v-btn small color="green" @click="updateSponsorship">Guardar</v-btn>
            </v-flex>
            <v-flex xs12>
                <v-toolbar color="white">
                    <v-toolbar-title class="green--text">
                        Secciones
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        color="green"
                        @click="addSection">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-flex>
            <v-flex
                xs12
                v-for="( item, i ) in form.sections" :key="i">
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-toolbar color="white">
                            <v-toolbar-title class="green--text">
                                Sección {{ i + 1 }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <template v-if="!formSectionsEditMode.sections[ i ] && currentSponsorship.id">
                                <v-btn
                                    flat
                                    icon
                                    color="red">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                                <v-btn
                                    flat
                                    icon
                                    @click="toggleSectionEditMode( i )"
                                    color="green">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                            </template>
                        </v-toolbar>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-toolbar color="grey darken-3">
                            <v-toolbar-title class="green--text">Español</v-toolbar-title>
                        </v-toolbar>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-toolbar color="grey darken-3">
                            <v-toolbar-title class="green--text">Ingles</v-toolbar-title>
                        </v-toolbar>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <ContentCard
                            lang="es"
                            :sectionPos="i"
                            ref="content_es"
                            :editMode="formSectionsEditMode.sections[ i ]"
                            @onContentAdded="onContentAdded( $event, i )"
                            @onContentPropertyChange="onContentPropertyChange"
                            @update="onSectionUpdated"></ContentCard>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <ContentCard
                            lang="en"
                            :sectionPos="i"
                            ref="content_en"
                            :editMode="formSectionsEditMode.sections[ i ]"
                            @update="onSectionUpdated"
                            :numberOfContents="numberOfContentsBySection[i]"></ContentCard>
                    </v-flex>
                    <v-flex xs12 d-flex align-right v-if="formSectionsEditMode.sections[ i ]">
                        <v-btn small color="red" @click="toggleSectionEditMode( i )">Cancelar</v-btn>
                        <v-btn small color="green" @click="updateSection( i )">Guardar</v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12>
                <v-toolbar color="white">
                        <v-toolbar-title class="green--text">Evidencias</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            color="green"
                            @click="addEvidence">
                            <v-icon>add</v-icon>
                        </v-btn>
                    </v-toolbar-title>
                </v-toolbar>
            </v-flex>
            <v-flex
                xs12
                v-for="( item, i ) in form.evidences" :key="i">
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-toolbar color="white">
                            <v-toolbar-title class="green--text">Evidencia {{ i + 1 }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-select
                                v-if="formSectionsEditMode.evidences[ i ] || !sponsorshipId"
                                :items="evidencesTypes"
                                label="Tipo"
                                single-line
                                light
                                item-text="text"
                                item-value="value"
                                v-model="form.evidences[ i ].type"
                            ></v-select>
                            <template v-if="!formSectionsEditMode.evidences[ i ] && currentSponsorship.id">
                                <p class="black--text"><strong>Tipo:</strong> {{ form.evidences[ i ].type }}</p>
                                <v-btn
                                    flat
                                    icon
                                    color="red"
                                    @click="deleteEvidenceConfirm( i )">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                                <v-btn
                                    flat
                                    icon
                                    color="green"
                                    @click="changeEvidenceMode( i )">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                            </template>
                        </v-toolbar>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-toolbar color="grey darken-3">
                            <v-toolbar-title class="green--text">Español</v-toolbar-title>
                        </v-toolbar>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-toolbar color="grey darken-3">
                            <v-toolbar-title class="green--text">Inglés</v-toolbar-title>
                        </v-toolbar>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <EvidencesCard
                            lang="es"
                            :type="form.evidences[ i ].type"
                            @optionWasAdded="evidenceOptionWasAdded( i )"
                            ref="evidence_es"
                            :evidencePos="i"
                            :editMode="formSectionsEditMode.evidences[ i ]"
                            @update="onEvidenceUpdated( $event, i )"></EvidencesCard>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <EvidencesCard
                            lang="en"
                            :type="form.evidences[ i ].type"
                            :numberOfOptions="numberOfOptions[ i ].value"
                            ref="evidence_en"
                            :evidencePos="i"
                            :editMode="formSectionsEditMode.evidences[ i ]"
                            @update="onEvidenceUpdated( $event, i )"></EvidencesCard>
                    </v-flex>
                    <v-flex xs12 d-flex align-right v-if="formSectionsEditMode.evidences[ i ]">
                        <v-btn small color="red" @click="cancelUpdateEvidence( i )">Cancelar</v-btn>
                        <v-btn small color="green" @click="updateEvidence( i )">Guardar</v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 text-xs-right>
                <v-btn
                    v-if="!sponsorshipId"
                    color="success"
                    @click="save()">Guardar</v-btn>
            </v-flex>
        </v-layout>
        <add-evidence-modal
            :dialog="showAddEvidenceModal"
            @close="showAddEvidenceModal = false"></add-evidence-modal>
        <add-section-modal
            :dialog="showAddSectionModal"
            @close="showAddSectionModal = false"></add-section-modal>
        <confirm-modal
            :dialog="showConfirm"
            :message="confirmMessage"
            @confirm="confirmResponse( $event )"></confirm-modal>
    </v-container>
</template>

<script>
    import Vue from 'vue';
    import { mapActions, mapGetters } from 'vuex';
    import TitleCard from './titleCard';
    import ContentCard from './contentCard';
    import EvidencesCard from './evidencesCard';
    import AddEvidenceModal from './addEvidenceModal';
    import addSectionModal from './addSectionModal';
    
    export default {
        name: 'SponsorshipForm',
        data() {
            return {
                confirmObj: {
                    section_pos: null,
                    evidence_pos: null
                },
                confirmMessage: '',
                showConfirm: false,
                showAddEvidenceModal: false,
                showAddSectionModal: false,
                formSectionsEditMode: {
                    header: false,
                    title: false,
                    sections: [],
                    evidences: []
                },
                numberOfContentsBySection: [],
                sponsorshipId: null,
                startDateMenu: false,
                endDateMenu: false,
                numberOfOptions: [],
                sponsorshipTypes: [
                    { value: 'single', text: 'Individual' },
                    { value: 'team', text: 'Equipo' },
                ],
                evidencesTypes: [
                    { value: 'text', text: 'text' },
                    { value: 'textarea', text: 'textarea' },
                    { value: 'image', text: 'image' },
                    { value: 'map', text: 'map' },
                    { value: 'question', text: 'question' },
                    { value: 'radio_list', text: 'radio_list' },
                    { value: 'checkbox_list', text: 'checkbox_list' },
                    { value: 'select_list', text: 'select_list' },
                    { value: 'select_list_related', text: 'select_list_related' },
                    { value: 'select_list_other', text: 'select_list_other' },
                ],
                form: {
                    type: '',
                    name_es: '',
                    name_en: '',
                    title_es: '',
                    title_en: '',
                    description_es: '',
                    description_en: '',
                    image_es: '',
                    image_en: '',
                    usage_limit: null,
                    date_from: null,
                    date_to: null,
                    sections: [],
                    evidences: []
                },
                rules: {
                    required: [
                        val => {

                            let res = ((val === 0 ? '0' : String(val)) || '').length > 0 || 'Este campo es obligatorio'
                            return res
                        }
                    ]
                }
           }
        },
        created() {

            this.sponsorshipId = this.$route.params.id;
            if ( this.sponsorshipId ) {
                this.loadSponsorship( {
                    id: this.sponsorshipId,
                    callback: () => this.setValuesOnEdition(),
                    errorCallback: e => {
                        throw new Error('Ha ocurrido un error al obtener el sponsorship seleccionado...', e);
                    }
                });
            }
        },
        components: {
            TitleCard,
            ContentCard,
            EvidencesCard,
            AddEvidenceModal,
            addSectionModal
        },
        computed: {
            ...mapGetters([
                'currentSponsorship'
            ])
        },
        watch: {
            currentSponsorship(newValue, oldValue) {
                
                if ( newValue ) {
                    
                    this.form.sections = [];
                    this.formSectionsEditMode.sections = [];
                    newValue.sections.forEach( section => {
                        this.formSectionsEditMode.sections.push(false);
                        this.form.sections.push({
                            id: section.id,
                            number: section.number,
                            title_es: section.title_es,
                            title_en: section.title_en,
                            contents: [
                                {},
                                {}
                            ]
                        });
                    });

                    this.form.evidences = [];
                    this.formSectionsEditMode.evidences = [];
                    newValue.evidences.forEach( evidence => {
                        this.formSectionsEditMode.evidences.push(false);
                        this.numberOfOptions.push({ value: evidence.options.length });

                        this.form.evidences.push({
                            ...evidence
                        });
                    });
                }
            }
        },
        methods: {
            ...mapActions([
                'createSponsorship',
                'loadSponsorship',
                'editSponsorship',
                'editEvidence',
                'deleteEvidence',
                'editSection'
            ]),
            setValuesOnEdition() {
                this.form.usage_limit = this.currentSponsorship.usage_limit;
                this.form.type = this.currentSponsorship.type;
                this.form.date_from = this.currentSponsorship.date_from;
                this.form.date_to = this.currentSponsorship.date_to;
            },
            onTitleUpdated( data ) {
                this.form[ `name_${ data.lang }` ] = data.name;
                this.form[ `title_${ data.lang }` ] = data.title;
                // this.form[ 'action' ] = data.action;
                this.form[ `description_${ data.lang }` ] = data.description;
                this.form[ `image_${ data.lang }` ] = data.image;
            },
            addSection() {
 
                if ( !this.currentSponsorship.id ) {

                    this.form.sections.push({
                        title_es: '',
                        title_en: '',
                        contents: [
                            {},
                            {}
                        ]
                    });
                } else {

                    this.showAddSectionModal = true;
                }
            },
            addEvidence() {

                if ( !this.currentSponsorship.id ) {
                    
                    this.form.evidences.push({
                        type: '',
                        placeholder_es: '',
                        placeholder_en: '',
                        description_es: '',
                        description_en: '',
                        options: []
                    });
                    this.numberOfOptions.push({ value: 0 });
                } else {

                    this.showAddEvidenceModal = true;
                }
            },
            onSectionUpdated({ sectionPos, form, addedContents }) {

                let langPos = form.lang === 'es' ? 0 : addedContents.length;
                this.form.sections[ sectionPos ][ `title_${ form.lang }` ] = form.title;
                this.form.sections[ sectionPos ].number = form.position + 1;
                this.form.sections[ sectionPos ].edit = false;

                Array.from(addedContents).forEach( ( content, i ) => {

                    if ( typeof i === 'number' ) {
                        
                        this.form.sections[ sectionPos ].contents[ langPos ] = {};
                        this.form.sections[ sectionPos ].contents[ langPos ].lang = form.lang;
                        this.form.sections[ sectionPos ].contents[ langPos ].text = content.text;
                        this.form.sections[ sectionPos ].contents[ langPos ].media = content.file || undefined;
                        this.form.sections[ sectionPos ].contents[ langPos ].action = content.action;
                        this.form.sections[ sectionPos ].contents[ langPos ].position = i + 1;
                        // this.formSectionsEditMode.sections[ sectionPos ] = false;
                        this.form.sections[ sectionPos ].contents[ langPos ].type
                            = content.content_type === 'text'
                                ? content.content_type
                                : content.media_type;
                        langPos++;
                    }
                });
            },
            save() {
                
                if (
                    this.$refs.titleCardEs.hasErrors() ||
                    this.$refs.titleCardEn.hasErrors()  ) {

                    return;
                }

                for ( let i = 0, length = this.form.sections.length; i < length; i++ ) {

                    if (
                        this.$refs[ 'content_es' ][ i ].hasErrors() ||
                        this.$refs[ 'content_en' ][ i ].hasErrors()  ) {

                        return;
                    }
                }

                for ( let i = 0, length = this.form.evidences.length; i < length; i++ ) {

                    if (
                        this.$refs[ 'evidence_es' ][ i ].hasErrors() ||
                        this.$refs[ 'evidence_en' ][ i ].hasErrors()  ) {

                        return;
                    }
                }            

                this.createSponsorship( this.form ); 
            },
            removeSection( i ) {
                
                this.form.sections.splice( i, 1 );
            },
            evidenceOptionWasAdded( i ) {

                this.form.evidences[ i ][ 'options' ].push({ option: [
                    { name: '', language: '' },
                    { name: '', language: '' },
                ]});
                this.numberOfOptions[ i ].value++;
            },
            onEvidenceUpdated( data, i ) {
                
                this.form.evidences[ i ][ `description_${ data.lang }` ] = data.description;
                this.form.evidences[ i ][ `placeholder_${ data.lang }` ] = data.placeholder;

                if ( data.options && !this.currentSponsorship.id ) {

                    // this.form.evidences[ i ][ 'options' ] = [];

                    for ( let x = 0, length = data.options.length; x < length; x++ ) {
                        
                        const langPos = data.lang === 'es' ? 0 : 1;

                        this.form.evidences[ i ][ 'options' ][ x ].option[ langPos ] = {
                            name: data.options[ x ].text,
                            language: data.lang
                        }
                    }
                }

            },
            onContentAdded( numberOfContents, i ) {

                this.numberOfContentsBySection[i] = numberOfContents;
                Vue.set(this.numberOfContentsBySection, i, numberOfContents);
            },
            onContentPropertyChange({ key, pos, newValue, sectionPos }) {

                this.$refs.content_en[ sectionPos ].modifyContent( key, pos, newValue );
            },
            updateSponsorship() {

                if (
                    this.$refs.titleCardEs.hasErrors() ||
                    this.$refs.titleCardEn.hasErrors()  ) {

                    return;
                }

                const data = {
                    usage_limit: this.form.usage_limit || undefined,
                    type: this.form.type || undefined,
                    date_from: this.form.date_from || undefined,
                    date_to: this.form.date_to || undefined,
                    name_es: this.form.name_es || undefined,
                    title_en: this.form.title_en || undefined,
                    title_es: this.form.title_es || undefined,
                    name_en: this.form.name_en || undefined,
                    description_es: this.form.description_es || undefined,
                    description_en: this.form.description_en || undefined,
                    image_es: this.form.image_es || undefined,
                    image_en: this.form.image_en || undefined,
                };

                console.log(data);

                this.editSponsorship({ 
                    id: this.sponsorshipId,
                    data,
                    callback: () => this.formSectionsEditMode.header = false
                });
            },
            changeEvidenceMode( i ) {
                
                Vue.set(this.formSectionsEditMode.evidences, i, !this.formSectionsEditMode.evidences[ i ])
            },
            updateEvidence( i ) {

                this.editEvidence({
                    data: this.form.evidences[ i ],
                    callback: response => this.loadSponsorship({
                        id: this.sponsorshipId,
                        callback: () => this.changeEvidenceMode( i )
                    })
                });
            },
            cancelUpdateEvidence( i ) {

                this.$refs.evidence_es[ i ].cleanFormOnCancel();
                this.$refs.evidence_en[ i ].cleanFormOnCancel();
                this.changeEvidenceMode( i );
            },
            deleteEvidenceConfirm( i ) {

                this.confirmObj.evidence_pos = i;
                this.confirmMessage = '¿Estas seguro de eliminar esta evidencia?';
                this.showConfirm = true;
            },
            confirmResponse( response ) {

                this.showConfirm = false;
                if ( response ) {

                    const { section_pos, evidence_pos } = this.confirmObj;

                    if ( section_pos ) {

                    } else if ( evidence_pos ) {
                        
                        this.deleteEvidence({
                            id: this.form.evidences[ evidence_pos ].id,
                            callback: () => this.loadSponsorship({ id: this.sponsorshipId, callback: () => this.confirmObj.evidence_pos = null })
                        });
                    }
                }
            },
            toggleSectionEditMode( i ) {

                console.log(this.formSectionsEditMode.sections[ i ]);
                Vue.set(this.formSectionsEditMode.sections, i, !this.formSectionsEditMode.sections[ i ]);
                console.log(this.formSectionsEditMode.sections[ i ]);
            },
            updateSection( i ) {

                for ( let i = 0, length = this.form.sections.length; i < length; i++ ) {

                    if (
                        this.$refs[ 'content_es' ][ i ].hasErrors( false ) ||
                        this.$refs[ 'content_en' ][ i ].hasErrors( false )  ) {

                        return;
                    }
                }

                const { id, number, title_es, title_en } = this.form.sections[ i ],
                    data = {
                        id,
                        title_es,
                        title_en,
                        number
                    };
                this.editSection({
                    data,
                    callback: () => this.toggleSectionEditMode( i )
                })
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/pages/sponsorships/sponsorshipForm.vue